import axios from "axios";
import NProgress from "nprogress";

const BikeSportApiClass = class BikeSportApi {
  constructor(headers) {
    this.apiAditionalHeaders = headers || null;
    this.endpointUrlPrefix = "";

    this.axiosInstance = axios.create({
      withCredentials: false,
      headers: {
        common: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    });

    this.initAxiosRequestInterceptors();
  }

  get instance() {
    return this.axiosInstance;
  }

  get endpointPrefix() {
    return this.endpointUrlPrefix;
  }

  initAxiosRequestInterceptors() {
    // Intercepta el request y agrega parámetros adicionales de configuración
    this.axiosInstance.interceptors.request.use(config => {
      NProgress.start();

      // URL Base para las peticiones
      config.baseURL = process.env.VUE_APP_BIKESPORT_BO_REST_API;

      // Token para BikeSport Lead Manager
      config.headers["X-BIKESPORT-API-TOKEN"] =
        process.env.VUE_APP_BIKESPORT_API_TOKEN;

      // Agrega los encabezados adicionales
      if (this.apiAditionalHeaders) {
        Object.keys(this.apiAditionalHeaders).forEach(key => {
          config.headers[key] = this.apiAditionalHeaders[key];
        });
      }

      return config;
    });

    // Intercepta la respuesta para detener NProgress
    this.axiosInstance.interceptors.response.use(
      response => {
        NProgress.done();
        return response;
      },
      error => {
        NProgress.done();
        return Promise.reject(error);
      }
    );
  }
};

export default BikeSportApiClass;
